<template>
    <div class="add-product g-flex g-w-full g-items-center g-cursor-pointer">
        <g-icon class="plus" name="plus" />
        <div>Add Product</div>
    </div>
</template>

<script>
    export default {
        name: 'AddProduct',
    };
</script>

<style lang="scss" scoped>
    .add-product {
        height: 75px;
        background-color: #F9FAFB;
        border: 1px #D7DBDF dashed;
        padding-left: 40px;
        .plus {
            margin-right: 4px;
            position: relative;
            top: -1px;
        }
    }
</style>
